export default __webpack_public_path__ + "static/media/icon-instagram.9590d828.svg";